export default __webpack_public_path__ + "static/media/img-slider-dlttaxi-2.6b121437.png";